import { render } from "./VipDetails.vue?vue&type=template&id=58120ea2&scoped=true"
import script from "./VipDetails.vue?vue&type=script&lang=js"
export * from "./VipDetails.vue?vue&type=script&lang=js"

import "./VipDetails.vue?vue&type=style&index=0&id=58120ea2&lang=stylus"
import "./VipDetails.vue?vue&type=style&index=1&id=58120ea2&scoped=true&lang=stylus"

import exportComponent from "/Users/test/Desktop/source/work/H5-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58120ea2"]])

export default __exports__